module.exports = __webpack_public_path__ + "images/stickers/taco-cool@2x.8f4ac7820629d5aac2e2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-cool@2x.png
// module id = i+LF
// module chunks = 1